import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'access-denied-page',
  standalone: true,
  template: `
  <div style="padding:80px 0 60px 0;">
  <h2>Access Denied</h2>
  <p style="text-align: center; padding-top:40px;">
    No permission.<br />
    Please contact Steven Westmoreland to request access.
  </p>
  </div>    
  `
})
export class AccessDeniedComponent {
  message = 'Permision not granted';
  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params['message']) this.message = params['message'];
    });
  }
}